import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { handleError } from '../../../../components/ui/err/handleError';
import { queries } from '../../../queries';

import type { AxiosCommonError } from '../../../types';
import type { IGetAiAgentModelListParams, IGetAiAgentModelSettingsHistoryParams } from './types';

interface IGetAiAgentModelListQueryOptions {
  suspense?: boolean;
}

export function useGetAiAgentModelList(params: IGetAiAgentModelListParams, options: IGetAiAgentModelListQueryOptions = {}) {
  return useQuery({
    ...queries.aiAgent.equipmentModelList(params),
    staleTime: 1000 * 60 * 5, // 5분
    enabled: !!params.companyId && params.companyId > 0,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
    ...options,
  });
}

export function useGetAiAgentModelSettingHistory(params: IGetAiAgentModelSettingsHistoryParams) {
  return useQuery({
    ...queries.aiAgent.modelSettingHistory(params),
    enabled: !!params.companyId && params.companyId > 0 && !!params.modelId && params.modelId > 0,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
